import { authHeader } from '../utils/auth-header';
import apis from '../config/api';
import axios from "axios";

export const vehicleService = {
    checkVehicleReg,
    vehiclesList
};


function checkVehicleReg(vehicleReg) {
    return axios.get(`${apis.vehicle}/CheckReg?regNo=${correctPlate(vehicleReg)}`, { headers: authHeader() });
}


function vehiclesList() {
    return axios.get(`${apis.vehicle}/VehiclesList`, { headers: authHeader() });
}


function correctPlate(plate){
    return plate.replace(/[^a-zA-Z0-9]/g, "");
}


// WEBPACK FOOTER //
// ./src/services/vehicleService.js